import $http from '../../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Método para obtener los riesgos del proceso de UN ene l formulario.
 *
 * @param {*} param0
 */
export async function getGre({commit, state}, filtro) {

    if (!state.cargando_select && filtro.length >= 3) {

        commit('establecerCargandoSelect', true);
        const parametros = {
            params: {
                filtro: filtro
            }
        };

        commit('dashboard/load', true, {root: true});
        await $http.get('adm_productos/un/gre', parametros)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('setGre', response.data.data);
                commit('establecerCargandoSelect', false);
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
                commit('establecerCargandoSelect', false);
            });
    }
}

/**
 * Método para obtener los riesgos del proceso de UN ene l formulario.
 *
 * @param Object {commit, state}: Acciones y estados base.
 * @param Boolean clearDataInicial: limpiar la data principal.
 */
export async function getRiesgos({commit, state}, clearDataInicial = true) {
    if (clearDataInicial) commit('resetselectedUn');

    if (!state.optprincipal.length || !state.optsecundario.length || !state.optsecundario1.length) {

        commit('dashboard/load', true, {root: true});
        await $http.get('adm_productos/un/riesgos')
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('RiesgoPrincipal', response.data);
                commit('RiesgoRiesgoSecundario', response.data);
                commit('RiesgoRiesgoSecundario1', response.data);
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Método que guarda los datos de naciones unidas del producto químico.
 *
 * @param {*} param0
 */
export async function guardaUn({commit, state, rootState}) {

    let id_producto = rootState.productos.selectedProduct.id;

    if (!id_producto) {
        id_producto = rootState.productos.selectedProduct.Idproducto;
    }

    commit('dashboard/load', true, {root: true});

    await $http.post(`adm_productos/un/crear/${id_producto}`, state.selectedUn)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 3000
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
            reject(error);
        });
}

/**
 * Método para obtener la información de Un del producto químico.
 *
 * @param {*} param0
 */
export async function getUn({commit, state, rootState, dispatch}, id) {

    commit('dashboard/load', true, {root: true});
    await $http.get(`adm_productos/un/ver/${id}`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setUn', response.data);
            dispatch('getGre', response.data.noun);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}


export async function generarRotuloUN({commit, state}, id) {
    commit('dashboard/load', true, {root: true});
    await $http.post(`adm_productos/rotulo_un/${id}`, state.rotul)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setRotuloUN', process.env.VUE_APP_API_URL + response.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}
